import React from "react";

const CommonButton = ({ children, ...props }) => {
  return (
    <button
      className={
        "common-button w-full h-auto md:max-w-96 md:h-12 px-4 py-3 rounded-full font-medium leading-normal tracking-tight common-button-disabled"
      }
      {...props}
    >
      {children}
    </button>
  );
};

export default CommonButton;
